import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Flex from "../../../../Flex";
import Stack from "../../../../Stack";
import { StatusBadge } from "../../../../StatusBadge";
import ValueText from "./components/ValueText";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OptionValueContents(_ref) {
  var label = _ref.label,
    statusBadgeProps = _ref.statusBadgeProps;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "horizontal",
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/_jsx(ValueText, {
      children: label
    }), statusBadgeProps && /*#__PURE__*/_jsx(Flex, {
      shouldShrink: false,
      children: /*#__PURE__*/_jsx(StatusBadge, _extends({}, statusBadgeProps))
    })]
  });
}
export default OptionValueContents;